var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.6035 4.23169H6.62218C5.29994 4.23169 4.23169 5.29994 4.23169 6.62218V61.6035C4.23169 62.9258 5.29994 63.994 6.62218 63.994H61.6035C62.9258 63.994 63.994 62.9258 63.994 61.6035V6.62218C63.994 5.29994 62.9258 4.23169 61.6035 4.23169ZM59.213 59.213H45.4602V40.8511H53.2293L54.3947 31.8344H45.4602V26.0748C45.4602 23.4602 46.1849 21.6823 49.9275 21.6823H54.701V13.6144C53.8718 13.5023 51.0406 13.2558 47.7387 13.2558C40.8511 13.2558 36.1373 17.4616 36.1373 25.1784V31.827H28.3533V40.8436H36.1448V59.213H9.01268V9.01268H59.213V59.213Z",
    fill: "#713D11"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.1dc0712db061495c8cf9a3c67cfb12d9.svg";
export { ForwardRef as ReactComponent };